export default __webpack_public_path__ + "static/media/excellent.5d1f0227.png";